import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M22.93 10.61 12.71.4A1 1 0 0 0 12 .1a1 1 0 0 0-.71.29L1.08 10.61a1 1 0 0 0 0 1.42l2.75 2.75a1 1 0 0 0 1.39 0l3.24-3.06a.26.26 0 0 1 .27 0 .25.25 0 0 1 .15.23v11a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-11a.25.25 0 0 1 .15-.23.27.27 0 0 1 .27 0l3.49 3.15a1 1 0 0 0 1.37 0L22.93 12a1 1 0 0 0 0-1.39"
    }, null, -1)
  ]));
}
const arrowUp = { render };
export {
  arrowUp as default,
  render
};
//# sourceMappingURL=arrow-up.svg.js.map
